<!-- 
 * @author song
 * @since 2022-04-21
 * @publisher  宏脉信息技术（广州）股份有限公司
 -->
<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <p>回收条件：</p>
      <div>
        超过<el-input-number
          :controls="false"
          style="width: 50px;margin: 0 10px;"
          v-model="form.dayConfig"
          controls-position="right"
          @change="handleChange"
          size="mini"
          :min="1"
        ></el-input-number
        >天未
        <el-select
          v-model="form.type"
          placeholder="请选择"
          style="width: 140px;margin: 0 10px;"
          size="mini"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        则系统自动回收手机号码
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false" size="mini">取 消</el-button>
        <el-button type="primary" @click="handleDefine" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  postResume,
  postResumedata,
} from "../../../../api/addFriends/addFriends.js";
export default {
  name: "setDialog",
  data() {
    return {
      dialogVisible: false,
      form: {
        dayConfig: 0,
        type: 1,
        corpId: "",
      },
      title: "",
      input: "",
      options: [
        {
          label: "未通过",
          value: 1,
        },
        {
          label: "未添加",
          value: 2,
        },
      ],
      value: "",
    };
  },
  components: {},
  methods: {
    handleClose() {
      this.dialogVisible = false;
    },
    async handleDefine() {
      if (!this.form.dayConfig) {
        return this.$message.warning("设置时间不能为空");
      }
      try {
        await postResume(this.form, localStorage.getItem("Authorization"));
        this.$message.success("设置成功");
      } catch (error) {
        this.$message.warning("设置失败");
      } finally {
        this.dialogVisible = false;
      }
    },
    async getData() {
      const res = await postResumedata(localStorage.getItem("Authorization"));
      console.log("XXXXXXXXX", res);
      this.form = {
        dayConfig: res.data.dayConfig,
        type: res.data.type,
        corpId: res.data.corpId,
      };
    },
    handleChange() {},
  },
};
</script>

<style lang="scss" scoped>
/deep/.add-per-input {
  margin-right: 10px;
  width: 200px;
  overflow: hidden;
  text-overflow: ellipsis;
  position: relative;
  cursor: pointer;

  .el-icon-close {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 5px;
  }
}
</style>
